<template>
  <div class="sm:col-span-3">
    <label
      v-if="label"
      v-text="label"
      :for="$id('basic-select')"
      class="block text-sm font-medium leading-5 text-gray-700"
    ></label>
    <div class="mt-1 rounded-md shadow-sm">
      <select
        :id="$id('basic-select')"
        v-bind="$attrs"
        v-on="inputListeners"
        :class="{'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red': hasError}"
        class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      >
        <slot />
      </select>
    </div>
  </div>
</template>


<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      required: false
    },
    errors: {
      required: false,
      default: null
    },
    errorKey: {
      required: false
    }
  },
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event.target.value);
          }
        }
      );
    },
    hasError() {
      return !!this.errors && !!this.errors[this.errorKey];
    }
  }
};
</script>

